/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/sidenav.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Component } from '@angular/core';
import { Features } from './context/features';
import * as i0 from "@angular/core";
import * as i1 from "./context/features";
export class SidenavComponent {
    /**
     * @param {?} features
     */
    constructor(features) {
        this.features = features;
        this.isOpen = true;
    }
}
SidenavComponent.decorators = [
    { type: Component, args: [{
                selector: 'sidenav',
                templateUrl: "sidenav.component.html",
            },] },
];
/** @nocollapse */
SidenavComponent.ctorParameters = () => [
    { type: Features }
];
/** @nocollapse */ SidenavComponent.ɵfac = function SidenavComponent_Factory(t) { return new (t || SidenavComponent)(i0.ɵɵdirectiveInject(i1.Features)); };
/** @nocollapse */ SidenavComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SidenavComponent, selectors: [["sidenav"]], decls: 0, vars: 0, template: function SidenavComponent_Template(rf, ctx) { }, encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SidenavComponent, [{
        type: Component,
        args: [{
                selector: 'sidenav',
                templateUrl: "sidenav.component.html",
            }]
    }], function () { return [{ type: i1.Features }]; }, null); })();
if (false) {
    /** @type {?} */
    SidenavComponent.prototype.isOpen;
    /** @type {?} */
    SidenavComponent.prototype.features;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2lkZW5hdi5jb21wb25lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi92aXNpb25pY3Mvbmcvc3JjL2FwcC9zaWRlbmF2LmNvbXBvbmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLE9BQU8sRUFBQyxTQUFTLEVBQUMsTUFBTSxlQUFlLENBQUM7QUFDeEMsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLG9CQUFvQixDQUFDOzs7QUFNNUMsTUFBTSxPQUFPLGdCQUFnQjs7OztJQUMzQixZQUNhLFFBQWtCO1FBQWxCLGFBQVEsR0FBUixRQUFRLENBQVU7UUFHeEIsV0FBTSxHQUFHLElBQUksQ0FBQztJQUZsQixDQUFDOzs7WUFQTCxTQUFTLFNBQUM7Z0JBQ1QsUUFBUSxFQUFHLFNBQVM7Z0JBQ3BCLFdBQVcsRUFBRyx3QkFBd0I7YUFDdkM7Ozs7WUFMTyxRQUFROztnRkFNSCxnQkFBZ0I7cURBQWhCLGdCQUFnQjtrREFBaEIsZ0JBQWdCO2NBSjVCLFNBQVM7ZUFBQztnQkFDVCxRQUFRLEVBQUcsU0FBUztnQkFDcEIsV0FBVyxFQUFHLHdCQUF3QjthQUN2Qzs7OztJQU1DLGtDQUFxQjs7SUFIakIsb0NBQTJCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtDb21wb25lbnR9IGZyb20gJ0Bhbmd1bGFyL2NvcmUnO1xuaW1wb3J0IHtGZWF0dXJlc30gZnJvbSAnLi9jb250ZXh0L2ZlYXR1cmVzJztcblxuQENvbXBvbmVudCh7XG4gIHNlbGVjdG9yIDogJ3NpZGVuYXYnLFxuICB0ZW1wbGF0ZVVybCA6IFwic2lkZW5hdi5jb21wb25lbnQuaHRtbFwiLFxufSlcbmV4cG9ydCBjbGFzcyBTaWRlbmF2Q29tcG9uZW50IHtcbiAgY29uc3RydWN0b3IoXG4gICAgICByZWFkb25seSBmZWF0dXJlczogRmVhdHVyZXMsXG4gICkge31cblxuICBwdWJsaWMgaXNPcGVuID0gdHJ1ZTtcbn1cbiJdfQ==